import { ChevronLeft } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { FC } from "react";

import { MainTitleProps } from "./components.interfaces";

const MainTitle: FC<MainTitleProps> = (props: MainTitleProps) => {
  const { title, onBackButtonClickHandler } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        marginBottom: 0,
        paddingBottom: 2,
        justifyContent: "start",
        flexGrow: 1,
        height: "var(--main-title-height)",
        px: 3,
        py: 0,
      }}
      data-testid="main-title"
    >
      {onBackButtonClickHandler ? (
        <IconButton
          onClick={onBackButtonClickHandler}
          data-testid="main-title-back-button"
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
      ) : null}
      <Typography variant="h4" data-testid="main-title-text">
        {title}
      </Typography>
    </Box>
  );
};

export default MainTitle;
